import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PaperBase from '../../../../Paper/PaperBase';
import LcElemensCard from '../../../../card/LcElemensCards';
import CurriculumElementsCards from '../../../../card/CurriculumElementsCards';
import GranularStepCard from '../../../../card/GranularStepCard';
import DialogWorkedExamples from '../FormWorkedExamples/DialogWorkedExamples';
import IconTooltipButton from '../../../../button/IconTooltipButton';

const CardGS = ({ lcs = [], levelId, level, nextLevel, onWorkedExamples, onTeachingSuggestions }) => {
  if (lcs.every((x) => x.granularSteps)) {
    let lcgs = [];
    lcs.forEach((lc) => {
      const granularSteps = lc.granularSteps
        ?.filter((step) => step.levelId === levelId)
        .map((_, i) => String(i));
      lcgs = [...lcgs, ...granularSteps];
    });
    lcgs = [...new Set(lcgs)];

    const items = lcgs;
    if (items.length > 0) {
      return items
        .map((item, index) => {
          const isLevel = index === 0;

          return (
            <div key={`granular-steps-${levelId}-gs-${item}`} className='flex flex-nowrap w-full gap-1'>
              <PaperBase
                backgroundColor={isLevel ? level.secondaryColor : 'var(--background)'}
                color={isLevel ? level.primaryColor : level?.secondaryColor}
                className='font-bold min-w-120px max-w-120px sticky left-0 z-10'
                outline={isLevel ? null : `1px solid ${level?.secondaryColor}`}
                children={isLevel ? level.name : `Working towards ${nextLevel?.name}`}
              />
              {lcs.map((lc) => {
                const gsslc = lc.granularSteps
                  ?.filter((step) => step.levelId === levelId)
                  ?.map((item) => ({ ...item, position: parseInt(item.id.split('gs-')[1]) }))
                  ?.sort((a, b) => a.position - b.position);

                const find = gsslc[index];
                return (
                  <GranularStepCard
                    key={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}`}
                    backgroundColor={find ? level?.primaryColor : null}
                    color={find ? level?.secondaryColor : null}
                    step={{ ...find }}
                    actionsTeachingSuggestions={(data) => (
                      <>
                        <IconTooltipButton
                          title='Preview teaching suggestion'
                          icon='expand-alt'
                          onClick={(e) => {
                            e.stopPropagation();
                            onTeachingSuggestions(
                              {
                                levelId: level._id,
                                levelName: level.name,
                                ...data
                              },
                              'preview'
                            );
                          }}
                          style={{
                            width: 24,
                            height: 24,
                            color: 'currentColor'
                          }}
                        />
                      </>
                    )}
                    actionsWorkedExamples={(data) => (
                      <IconTooltipButton
                        title='Preview worked example'
                        icon='expand-alt'
                        onClick={(e) => {
                          e.stopPropagation();
                          onWorkedExamples(
                            {
                              levelId: level._id,
                              levelName: level.name,
                              lcId: lc._id,
                              ulId: lc.ulId,
                              classId: lc.classId,
                              ...data
                            },
                            'preview'
                          );
                        }}
                        style={{
                          width: 24,
                          height: 24,
                          color: 'currentColor'
                        }}
                      />
                    )}
                  />
                );
              })}
            </div>
          );
        })
        .reverse();
    }
  }

  return [];
};

const FormGranularStepsPreview = ({ lcs = [] }) => {
  const [modal, setModal] = useState(null);

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const lcsElements = {};
  let levelsId = [];
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements;
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId) || [];
    levelsId = [...levelsId, ...lvls];
  });
  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position);

  return (
    <div className={['py-1 flex flex-col gap-1', lcs.length > 3 ? 'w-fit' : 'w-auto'].join(' ')}>
      {levelsRender.map((item, index) => (
        <React.Fragment key={`granular-steps-level-${item._id}`}>
          <CardGS
            lcs={lcs}
            levelId={item._id}
            level={{
              ...item,
              primaryColor: minMarking?.primaryColor,
              secondaryColor: minMarking?.secondaryColor
            }}
            nextLevel={levelsRender[index - 1]}
            onWorkedExamples={(form, type) => setModal({ form, type, element: 'worked-examples' })}
            onTeachingSuggestions={(form, type) => setModal({ form, type, element: 'teaching-suggestions' })}
          />
        </React.Fragment>
      ))}
      <LcElemensCard currentCurriculum={currentCurriculum} lcs={lcs || []} />
      <CurriculumElementsCards currentCurriculum={currentCurriculum} lcs={lcs || []} />
      {modal && (
        <DialogWorkedExamples
          open={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={() => {}}
          type={`${modal.type}-granular-step`}
          element={modal.element ? modal.element : 'worked-examples'}
        />
      )}
    </div>
  );
};

export default FormGranularStepsPreview;
